<h2 mat-dialog-title>{{ 'sharePointBlock.newFolder' | translate }}</h2>
<mat-dialog-content>
    <div class="folder-tree-footer">
        <span style="display:block;margin-bottom:.5rem">
            <i class="fa-solid fa-folder-plus "></i>
            <!-- {{ 'sharePointBlock.newFolder' | translate }} -->
            {{ 'sharePointBlock.subFolder' | translate }} <!--<strong>{{folderName}}</strong>-->
        </span>

            <div class="row" dense>
                <div class="col">
                    <mat-form-field appearance="outline" class="small">
                        <mat-label>{{ 'sharePointBlock.folderName' | translate }}</mat-label>
                        <input matInput [(ngModel)]="folderName" name="newFolderName" required>
                    </mat-form-field>
                </div>
            </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="col-auto">
        <button mat-button (click)="onNoClick()">{{
            'cancel' | translate }}</button>
        <button mat-flat-button color="primary" type="button" class="form-button" [disabled]="!folderName.trim()" [mat-dialog-close]="folderName">{{
            'create' | translate }}</button>
    </div>
</mat-dialog-actions>